// extracted by mini-css-extract-plugin
export default {"title":"W--z","warning":"X--z","sizeOptionsLegendText":"Y--z"};